import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_DELETE, llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI, TratamientoDeVariableString } from '../../Varios';

export const function_ABM_EEX_ClientesPersonasRelevantes_Listar = async (IdCliente) => {
    const NombreFuncion = "function_ABM_EEX_ClientesPersonasRelevantes_Listar"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_ClientesPersonasRelevantes/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCliente);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_ClientesPersonasRelevantes_Insertar = async (Objeto) => {
    const NombreFuncion = "function_ABM_EEX_ClientesPersonasRelevantes_Insertar";

    try {
        const objetoResult = await llamadaAPI_POST("ABM_EEX_ClientesPersonasRelevantes/Insertar", Objeto);
        return objetoResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_EEX_ClientesPersonasRelevantes_Modificar = async (Objeto) => {
    const NombreFuncion = "function_ABM_EEX_ClientesPersonasRelevantes_Modificar";

    try {
        await llamadaAPI_PUT("ABM_EEX_ClientesPersonasRelevantes/Modificar", Objeto);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_EEX_ClientesPersonasRelevantes_Generar_JSON = async (IdCliente,
    Nombre, Apellido, Cargo, Telefono, Email) => {
    const NombreFuncion = "function_ABM_EEX_ClientesPersonasRelevantes_Generar_JSON";

    try {
        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            IdCliente: IdCliente,
            Nombre: Nombre,
            Apellido: Apellido,
            Cargo: Cargo,
            Telefono: Telefono,
            Email: Email
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_ABM_EEX_ClientesPersonasRelevantes_Eliminar = async (IdCliente, Nombre, Apellido) => {
    const NombreFuncion = "function_VEN_ABM_EEX_ClientesPersonasRelevantes_Eliminar"

    try {
        const resulData = await llamadaAPI_DELETE("ABM_EEX_ClientesPersonasRelevantes/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            IdCliente + "/" +
            TratamientoDeParametroParaURI(Nombre) + "/" +
            TratamientoDeParametroParaURI(Apellido));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};
